import { useState } from 'react'
import { toast } from 'sonner'

interface UseBulkDeleteOptions<T> {
  selected: T[]
  getId: (item: T) => string
  deleteFn: (id: string) => Promise<unknown>
  /** Singular entity label, e.g. "expense" → "2 expenses deleted" */
  label: string
  onSuccess: () => void
}

export function useBulkDelete<T>({
  selected,
  getId,
  deleteFn,
  label,
  onSuccess,
}: UseBulkDeleteOptions<T>) {
  const [open, setOpen] = useState(false)

  async function handleBulkDelete() {
    const results = await Promise.allSettled(
      selected.map((item) => deleteFn(getId(item))),
    )
    const failed = results.filter((result) => result.status === 'rejected').length
    const succeeded = results.length - failed
    if (failed > 0) {
      toast.error('Some deletions failed', {
        description: `${succeeded} deleted, ${failed} failed.`,
      })
    } else {
      toast.success(`${succeeded} ${label}${succeeded === 1 ? '' : 's'} deleted`)
    }
    setOpen(false)
    if (failed === 0) {
      onSuccess()
    }
  }

  return { open, setOpen, handleBulkDelete }
}
